import { createBrowserClient } from '@supabase/ssr'

/**
 * Supabase client for browser (client-side).
 * Uses @supabase/ssr which stores the session in httpOnly cookies
 * (chunked if the session exceeds the 4096-byte cookie limit).
 *
 * The cookies are named sb-turno-token (or sb-turno-token.0, .1, ...).
 * The backend middleware reassembles these chunks to verify the JWT.
 */
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
